var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, Stack } from "@mui/material";
import Typography from "@mui/material/Typography";
/**
 * Program Detail Component
 * @param detailName - Name of the detail
 * @param detailValue - Value of the detail
 * @param rest - Accepts all MUI Grid props, which are passed to the container Grid component
 */
export const ProgramDetail = (_a) => {
    var { detailName, detailValue } = _a, rest = __rest(_a, ["detailName", "detailValue"]);
    return (_jsx(Grid, Object.assign({ item: true, xx: 12 }, rest, { children: _jsxs(Stack, Object.assign({ display: "flex", flexDirection: "column", alignItems: "flex-start", marginBottom: 2 }, { children: [_jsx(Typography, Object.assign({ variant: "h3", color: "primary" }, { children: detailName })), !!detailValue && _jsx(Typography, { children: detailValue })] })) })));
};
